export const getAllSpecialtiesConfig = () => ({
  url: `/all_specialties`,
});

export const addSpecialtyConfig = () => ({
  url: `/create_specialty`,
});

export const getSpecialtyByIdConfig = (id) => ({
  url: `/get_specialty_by_id/${id}`,
});

export const editSpecialtyConfig = (id) => ({
  url: `/update_specialty/${id}`,
});

export const deleteSpecialtyConfig = (id) => ({
  url: `/delete_specialty/${id}`,
});

export const generateOnboardingScriptConfig = () => ({
  url: `/onboarding/demospecialty`,
});
